/**
 * Portal Manta · KbNormas
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { KB_NORMAS } from '../../data/kb-normas.js';

function KbNormas(){
  const [escopo,setEscopo]=useState('Todos');
  const escopos=['Todos','geometria','quantitativos','custos','composições'];
  const rows=KB_NORMAS.filter(n=>escopo==='Todos'||n.escopo.includes(escopo));
  const escopoCor={geometria:{bg:V.blb,c:V.bl},quantitativos:{bg:V.orp,c:V.or},custos:{bg:V.gnb,c:V.gn},'composições':{bg:'#F5F3FF',c:'#6D28D9'}};
  return(<div style={{padding:'12px 16px'}}>
    <div style={{marginBottom:10,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
      <div>
        <div style={{fontSize:12.5,fontWeight:700,color:V.br2}}>Normas & Referências Externas</div>
        <div style={{fontSize:10.5,color:V.g5,marginTop:2}}>Parâmetros para geometria · levantamento de quantidades · composições de custos · {KB_NORMAS.length} normas cadastradas</div>
      </div>
      <button style={{padding:'6px 12px',background:V.or,color:'#fff',border:'none',borderRadius:6,fontSize:10,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>+ Adicionar norma</button>
    </div>
    <div style={{display:'flex',gap:5,marginBottom:10,flexWrap:'wrap'}}>
      {escopos.map(e=>{
        const on=escopo===e;
        const ct=e==='Todos'?KB_NORMAS.length:KB_NORMAS.filter(n=>n.escopo.includes(e)).length;
        return(<button key={e} onClick={()=>setEscopo(e)} style={{padding:'4px 10px',borderRadius:16,fontSize:10,fontWeight:on?700:500,border:`1px solid ${on?V.or:V.g2}`,background:on?V.or:'#fff',color:on?'#fff':V.g5,cursor:'pointer',fontFamily:'inherit',textTransform:'capitalize'}}>{e} · {ct}</button>);
      })}
    </div>
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(380px,1fr))',gap:10}}>
      {rows.map(n=>(<div key={n.id} style={{background:'#fff',border:`1px solid ${V.g2}`,borderRadius:10,padding:'11px 13px',borderLeft:`3px solid ${V.or}`}}>
        <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:5}}>
          <span style={{fontSize:9.5,fontWeight:700,color:V.br2,background:V.orp,padding:'2px 7px',borderRadius:4}}>{n.codigo}</span>
          <span style={{fontSize:8.5,color:V.g4,fontFamily:'monospace'}}>{n.id}</span>
          <span style={{fontSize:8.5,color:V.gn,background:V.gnb,padding:'1px 6px',borderRadius:10,fontWeight:600,marginLeft:'auto'}}>● {n.status}</span>
        </div>
        <div style={{fontSize:11,fontWeight:700,color:V.br,lineHeight:1.35,marginBottom:4}}>{n.titulo}</div>
        <div style={{fontSize:9.5,color:V.g5,marginBottom:6}}><b style={{color:V.g7}}>{n.emissor}</b> · vigência {n.vigencia}</div>
        <div style={{fontSize:9.5,color:V.g7,lineHeight:1.5,marginBottom:7,fontStyle:'italic'}}>{n.uso}</div>
        <div style={{display:'flex',gap:3,flexWrap:'wrap',marginBottom:5}}>
          {n.escopo.map(es=>{
            const c=escopoCor[es]||{bg:V.g1,c:V.g5};
            return(<span key={es} style={{fontSize:8.5,fontWeight:700,color:c.c,background:c.bg,padding:'2px 7px',borderRadius:10,textTransform:'capitalize'}}>{es}</span>);
          })}
        </div>
        <div style={{display:'flex',gap:3,flexWrap:'wrap'}}>
          {n.tags.map(t=>(<span key={t} style={{fontSize:8.5,color:V.g5,background:V.g1,padding:'1px 5px',borderRadius:3}}>#{t}</span>))}
        </div>
      </div>))}
    </div>
    <div style={{marginTop:12,padding:'10px 12px',background:V.g1,borderRadius:8,fontSize:10,color:V.g5,lineHeight:1.5}}>
      <b style={{color:V.br}}>Como se integra à KB:</b> normas entram como <b>referências externas</b> à base (não vêm dos orçamentos). Cada campo da KB Curada vincula à(s) norma(s) que o parametriza. O Extrator ANTT consulta normas para validar extração (ex.: classe de rodovia → raio mínimo IPR-724). Simulações Paramétricas usam coeficientes das ISC-022/ISC-031 para dimensionar quantidades.
    </div>
  </div>);
}

export { KbNormas };
export default KbNormas;
